import { createTheme } from '@mui/material/styles';


// Create a theme instance.
const theme = createTheme({
  colorSchemes: {
    dark: false,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          fontWeight: '700',
          minWidth: '145px',
          variants: [
            {
              props: { variant: 'outlined' },
              style: {
                color: 'black',
              },
            },
          ],
        },
      },
    },
  },
  typography: {
    fontFamily: [
      'GlacialIndifference, sans-serif'
    ].join(','),
    h1: {
      fontSize: '4rem',
      fontWeight: 600,
      letterSpacing: '0.1rem'
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      letterSpacing: '0.1rem'
    },
    h3: {
      fontSize: '1rem',
      fontWeight: 600,
      letterSpacing: '0.1rem'
    }, 
    h4: {
      fontSize: '0.5rem',
      fontWeight: 600,
      letterSpacing: '0.1rem'
    },
    body1: {
      fontSize: '2rem',
      letterSpacing: '0.1rem'
    },
    body2: {
      fontSize: '1.5rem',
      letterSpacing: '0.1rem'
    },
    subtitle1: {
      fontSize: '0.8rem',
      letterSpacing: '0.1rem'
    },
    subtitle2: {
      fontSize: '0.5rem',
      letterSpacing: '0.1rem'
    },
  },
  palette: {
    primary: {
      main: '#60A5FA',
    },
    secondary: {
      main: '#FFD450'
    },
    // background: {
    //   paper: '#262529'
    // },
    // text: {
    //   primary: '#FFFF'
    // }
  }
});

export default theme;
